





























import { Component, Ref, Vue } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import {
  ComBoxFactoryResetFlag,
  FACTORY_RESET_OPTIONS,
  combineFactoryResetFlags,
  getFactoryResetConsequenceKeys,
} from "@/utils/combox/ComBoxFactoryReset";

/**
 * Picks what a factory reset of a ComBox or Mini resets (IRES-only, opened from the box settings).
 * The datalog reset is ticked by default: it is what recovers a box whose run list fell back
 * (firmware-references/drying-without-run-after-directory-rollback.md).
 *
 * `show()` resolves with the combined flags, or null when cancelled.
 */
@Component({ components: { "base-dialog": BaseDialogComponent } })
export default class ComBoxFactoryResetDialogComponent extends Vue {
  @Ref("baseDialog")
  baseDialog!: BaseDialogComponent;

  readonly options = FACTORY_RESET_OPTIONS;
  flags: ComBoxFactoryResetFlag[] = [];

  private resolve: ((flags: number | null) => void) | null = null;

  show(serialNumber: string): Promise<number | null> {
    this.flags = [ComBoxFactoryResetFlag.DATALOG];

    // Persistent: a command for a device is confirmed or cancelled, never clicked away.
    // closeOnSave false: onConfirm closes the dialog once the choice is handed over.
    this.baseDialog.show({
      title: this.$t("comBoxSettings.factoryReset.title", [serialNumber]).toString(),
      positiveButtonText: this.$t("comBoxSettings.factoryReset.confirm").toString(),
      negativeButtonText: this.$t("common.abort").toString(),
      maxWidth: 560,
      persistent: true,
      closeOnSave: false,
    });

    return new Promise((resolve) => (this.resolve = resolve));
  }

  /** What the reset does, one sentence a line, for the ticked flags. */
  get consequenceLines(): string[] {
    return getFactoryResetConsequenceKeys(this.flags).map((key) =>
      this.$t(`comBoxSettings.factoryReset.consequences.${key}`).toString()
    );
  }

  onConfirm() {
    const flags = combineFactoryResetFlags(this.flags);

    this.baseDialog.isShowing = false;
    this.resolve?.(flags);
    this.resolve = null;
  }

  /** BaseDialog has already closed itself here. */
  onCancel() {
    this.resolve?.(null);
    this.resolve = null;
  }
}
